import { COMMON_DATE_TIME_UTC_FORMAT } from '../app/commons/constants/constants'
import dayjs from '../app/commons/utils/dayjsUtils'

export const cypressStartTime = dayjs
  .utc()
  .add(1, 'hour')
  .format(COMMON_DATE_TIME_UTC_FORMAT)

export const cypressStartOfTheMonthMinusTwoHours = dayjs
  .utc()
  .startOf('month')
  .subtract(2, 'hour')
  .format(COMMON_DATE_TIME_UTC_FORMAT)

export const cypressNowMinusOneHour = dayjs
  .utc()
  .subtract(1, 'hour')
  .format(COMMON_DATE_TIME_UTC_FORMAT)

export const cypressNowPlusOneHour = dayjs
  .utc()
  .add(1, 'hour')
  .format(COMMON_DATE_TIME_UTC_FORMAT)

export const cypressEndOfTheMonthPlusOneHours = dayjs
  .utc()
  .endOf('month')
  .add(1, 'hour')
  .format(COMMON_DATE_TIME_UTC_FORMAT)

export const cypressEndOfTheMonthPlusTwoHours = dayjs
  .utc()
  .endOf('month')
  .add(2, 'hour')
  .format(COMMON_DATE_TIME_UTC_FORMAT)

export const cypressEndOfTheMonthPlusDay = dayjs
  .utc()
  .endOf('month')
  .add(1, 'day')
  .format(COMMON_DATE_TIME_UTC_FORMAT)

export const DISABLE_TRACKING = 'disableTracking'
export const CYPRESS_TEST_DATE_TIME_FORMAT = 'MM-DD-YYYY HH:mm:ss'
export const CAMPAIGN_BADGE_LABEL_ID = 'badge-1'
export const CY_SELECTORS = {
  NUMBER_INPUT: 'number-input',
  STEPPER_BUTTON: 'stepper-btn',
  CUSTOM_DATE_RANGE_PICKER: 'custom-date-range-picker',
  ACHIEVEMENT_ID: 'achievement-id',
  ACHIEVEMENT_DETAILS_TOTAL_RECORDS: 'achieviement-details-total-records',
  ACHIEVEMENT_DETAILS_VALID_RECORDS: 'achieviement-details-valid-records',
  ACHIEVEMENT_DETAILS_INVALID_RECORDS: 'achieviement-details-invalid-records',
  BEHAVIOR_UPLOAD_TITLE: 'behavior-upload-title',
  BEHAVIOR_ID: 'behavior-id',
  BEHAVIOR_DETAILS_TOTAL_RECORDS: 'behavior-details-total-records',
  BEHAVIOR_DETAILS_VALID_RECORDS: 'behavior-details-valid-records',
  UPLOAD_POP_UP_TITLE: 'upload-pop-up-title',
  UPLOAD_POP_UP_MESSAGE: 'upload-pop-up-message',
  UPLOAD_POP_UP_TOTAL_RECORDS: 'upload-pop-up-total-records',
  UPLOAD_POP_UP_VALID_RECORDS: 'upload-pop-up-valid-records',
  UPLOAD_POP_UP_INVALID_RECORDS: 'upload-pop-up-invalid-records',
  FORGOT_PASSWORD_BTN: 'forgot-password-btn',
  FORGOT_PASSWORD_VERIFY_BTN: 'forgot-password-verify-btn',
  FORGOT_PASSWORD_TITLE: 'forgot-password-title',
  FORGOT_PASSWORD_POP_TITLE: 'forgot-password-pop-title',
  AWAIT_SPINNER: 'await-spinner',
  TENANT_SELECTOR: 'tenant-selector',
  TENANT_NAME: 'tenant-name',
  EMAIL: 'email',
  PASSWORD: 'password',
  LOGIN_BTN: 'login-btn',
  ERROR_SCREEN_TEXT: 'error-screen-text',
  LOGIN_ERROR_SCREEN_TEXT: 'error-screen-text',
  CAMPAIGN_ID: 'campaign-id',
  CAMPAIGNS_TABLE: 'campaigns-table',
  CAMPAIGN_TYPE: 'campaign-type',
  CAMPAIGN_USERS_PARTICIPATING_TABLE: 'campaign-users-participating-table',
  CAMPAIGN_USERS_PARTICIPATING_OPTIONS_BTN:
    'campaign-users-participating-options-btn',
  CAMPAIGN_USERS_PARTICIPATING_DOWNLOAD_BTN:
    'campaign-users-participating-download-btn',
  CREATE_CAMPAIGN_BTN: 'create-campaign-btn',
  NEW_CAMPAIGN_TITLE: 'new-campaign-title',
  EDIT_CAMPAIGN_TITLE: 'edit-campaign-title',
  ACTION_CAMPAIGN_SOURCE_ERROR: 'action-campaign-source-error',
  LOCATION_CAMPAIGN_GEO_ERROR: 'location-geo-json-error',
  LOCATION_CAMPAIGN_ADD_INFO_BTN: 'location-add-info-btn',
  MULTI_CAMPAIGN_TRANSACTIONAL_FILTER_ERROR: 'multi-transactional-filter-error',
  TRANSACTION_CAMPAIGN_FILTER_ERROR: 'transaction-campaign-filter-error',
  TIER_CAMPAIGN_BEHAVIOR_TYPE: 'tier-behavior-type',
  CAMPAIGN_MORE_BTN: 'campaign-more-btn',
  CAMPAIGN_MORE_CHILD_BTN: 'campaign-more-child-btn',
  CAMPAIGN_REORDER_UI_BTN: 'campaign-reorder-ui-btn',
  CAMPAIGN_STATUS_DIALOG_OPTION: 'campaign-status-dialog-option',
  FEATURED_CAMPAIGN_REORDER_UI_BTN: 'featured-campaign-reorder-ui',
  CAMPAIGN_DETAILS_ID: 'campaign-details-id',
  CAMPAIGN_DETAILS_TITLE: 'campaign-details-title',
  CAMPAIGN_DETAILS_INFO: 'campaign-details-info',
  CAMPAIGN_DETAILS_STATUS: 'campaign-details-status',
  CAMPAIGN_EXTERNAL_ADD_RULE_BTN: 'campaign-external-add-rule-btn',
  CAMPAIGN_EXTERNAL_ADD_RULE_DIALOG: 'campaign-external-add-rule-dialog',
  CAMPAIGN_EXTERNAL_ADD_RULE_DIALOG_BTN:
    'campaign-external-add-rule-dialog-btn',
  CAMPAIGN_EXTERNAL_CREATE_RULE_DIALOG:
    'campaign-external-create-rule-dialog-btn',
  DUPLICATED_CAMPAIGN_TITLE: 'duplicated-campaign-title',
  TRANSLATIONS_SELECT_OPTIONS: 'translations-select-options',
  TRANSLATIONS_MORE_BTN: 'translations-more-btn',
  TRANSLATIONS_MORE_CHILD_BTN: 'translations-more-child-btn',
  TRANSLATIONS_SELECT_SELECTED_VALUES: 'translations-select-selected-values',
  TRANSLATIONS_TRANSLATED_VALUE: 'translations-translated-value',
  SELECT_OPTIONS: 'select-options',
  SELECT_SELECTED_VALUES: 'select-selected-values',
  DATE_PICKER_ERROR_MSG: 'date-picker-error-message',
  SEGMENT_OPEN_ADD_DIALOG_BTN: 'open-add-segment-dialog-btn',
  SEGMENT_DIALOG_DESCRIPTION: 'add-segment-description',
  SEGMENT_ADD_BTN: 'add-segment-btn',
  SEGMENT_LIST_TABLE: 'segment-list-table',
  SEGMENT_LIST_ROW: 'segment-list-row',
  SEGMENT_OPEN_REMOVE_BTN: 'open-remove-segment-btn',
  SEGMENT_REMOVE_BTN: 'remove-segment-btn',
  FILE_UPLOADER_MSG: 'file-uploader-message',
  FILE_UPLOADER_INPUT: 'file-uploader-input',
  CAMPAIGN_CATEGORY_REORDER_UI_BTN: 'campaign-category-reorder-ui-btn',
  CAMPAIGN_CATEGORY_ID: 'campaign-category-id',
  CAMPAIGN_CATEGORY_DELETE_BTN: 'campaign-category-delete',
  CATEGORY_DELETE_DIALOG_TITLE: 'category-delete-dialog-title',
  CAMPAIGN_CATEGORY_TABLE: 'campaign-category-table',
  CAMPAIGN_CATEGORY_TABLE_ROW: 'campaign-category-table-row',
  CAMPAIGN_CATEGORY_DETAILS_ID: 'campaign-category-details-id',
  CAMPAIGN_CATEGORY_DETAILS_NAME: 'campaign-category-details-name',
  CAMPAIGN_CATEGORY_DETAILS_ICON: 'campaign-category-details-icon',
  CAMPAIGN_CATEGORY_DETAILS_UI_POSITION:
    'campaign-category-details-ui-position',
  OFFERS_TABLE: 'offers-table',
  OFFERS_LIST: 'offers-list',
  NEW_OFFER_TITLE: 'new-offer-title',
  OFFER_ID: 'offer-id',
  OFFER_REORDER_UI_BTN: 'offer-reorder-ui-btn',
  OFFER_TYPE: 'offer-type',
  OFFER_DETAILS_TITLE: 'offer-details-title',
  OFFER_DETAILS_NAME: 'offer-details-name',
  OFFER_DETAILS_TYPE: 'offer-details-type',
  OFFER_DETAILS_SUBTITLE: 'offer-details-subtitle',
  OFFER_DETAILS_REAL_POINTS: 'offer-details-real-points',
  OFFER_DETAILS_LISTED_POINTS: 'offer-details-listed-points',
  OFFER_DETAILS_MORE_CHILD_BTN: 'offer-details-more-child-btn',
  OFFER_DETAILS_MORE_BTN: 'offer-details-more-btn',
  OFFER_FUNDS_REDEMPTION_BTN: 'offer-funds-redemption_btn',
  DUPLICATED_OFFER_TITLE: 'duplicated-offer-title',
  OFFER_ADD_COUPONS_BTN: 'offer-add-coupons-btn',
  OFFER_UNIQUE_COUPON_FIELD: 'offer-unique-coupon-field',
  OFFER_COUPONS_POP_UP_TITLE: 'offer-coupons-pop-up-title',
  OFFER_COUPONS_TABLE_ROW: 'offer-coupons-table-row',
  OFFER_COUPON_CODE: 'offer-coupon-code',
  OFFER_COUPONS_TABLE_LIST_MORE_BTN: 'offer-coupons-table-list-more-btn',
  OFFER_COUPONS_TABLE_MORE_BTN: 'offer-coupons-table-more-btn',
  OFFER_COUPONS_TABLE: 'offer-coupons-table',
  OFFER_CATEGORY_REORDER_UI_BTN: 'offer-category-reorder-ui-btn',
  OFFERS_CATEGORY_TABLE: 'offers-category-table',
  OFFER_CATEGORY_TABLE_ROW: 'offer-category-table-row',
  OFFER_CATEGORY_ID: 'offer-category-id',
  OFFER_CATEGORY_DETAILS_NAME: 'offer-category-details-name',
  OFFER_CATEGORY_DETAILS_EDIT_TITLE: 'offer-category-details-edit-title',
  OFFER_CATEGORY_DETAILS_ICON: 'offer-category-details-icon',
  OFFER_CATEGORY_DETAILS_UI_POSITION: 'offer-category-details-ui-position',
  OFFER_CATEGORY_DELETE_BTN: 'offer-category-delete',
  OFFER_CATEGORY_DETAILS_ID: 'offer-category-details-id',
  USERS_TABLE: 'users-table',
  USERS_TABLE_ID: 'users-table-id',
  USER_DETAILS_ADD_USER_TO_SEGMENT_BTN: 'user-details-add-user-to-segment-btn',
  USER_DETAILS_STATUS: 'user-details-status',
  USER_DETAILS_TITLE: 'user-details-title',
  USER_DETAILS_OPEN_OPTIONS_BTN: 'user-details-open-options-btn',
  USER_DETAILS_OPTIONS_BTN: 'user-details-options-btn',
  USER_DETAILS_STATUS_DIALOG_TITLE: 'user-details-status-dialog-title',
  USER_DETAILS_CAMPAIGN_TABLE: 'user-details-campaign-table',
  USER_DETAILS_CAMPAIGN_TABLE_ROW: 'user-details-campaign-table-row',
  USER_DETAILS_CAMPAIGN_TAB_COUNT: 'user-details-campaign-tab-count',
  USER_DETAILS_CAMPAIGN_TABLE_ID: 'user-details-campaign-table-id',
  USER_DETAILS_OFFERS_TABLE: 'user-details-offers-table',
  USER_DETAILS_OFFERS_TABLE_ROW: 'user-details-offers-table-row',
  USER_DETAILS_OFFERS_TABLE_ID: 'user-details-offers-table-id',
  USER_DETAILS_OFFERS_TAB_COUNT: 'user-details-offers-tab-count',
  USER_DETAILS_TRANSACTIONS_TABLE: 'user-details-transactions-table',
  USER_DETAILS_APPS_TABLE: 'user-details-apps-table',
  USER_DETAILS_APPS_TABLE_ROW: 'user-details-apps-table-row',
  USER_DETAILS_APPS_TAB_PROVIDERS_COUNT:
    'user-details-apps-tab-providers-count',
  USER_DETAILS_APPS_TAB_CONNECTED_COUNT:
    'user-details-apps-tab-connected-count',
  USER_DETAILS_UPDATES_TABLE: 'user-details-updates-table',
  USER_DETAILS_UPDATES_TABLE_ROW: 'user-details-updates-table-row',
  USER_DETAILS_UPDATES_TABLE_ID: 'user-details-updates-table-id',
  USER_DETAILS_UPDATES_TAB_COUNT: 'user-details-updates-tab-count',
  TENANT_SIGN_STEPS_DELETE_BTN: 'tenant-sign-steps-delete-tn',
  TENANT_SIGN_STEPS_TITLE: 'tenant-sign-steps-title',
  TENANT_SIGN_STEPS_DESCRIPTION: 'tenant-sign-steps-description',
  TENANT_SIGN_STEPS_ADD_BTN: 'tenant-sign-steps-add-btn',
  TENANT_TRANSLATIONS_COLLAPSE: 'tenant-collapse-section',
  TENANT_REFERRAL_TITLE: 'tenant-referral-title',
  PROVIDER_ID: 'provider-id',
  PROVIDER_EDIT_TITLE: 'provider-edit-title',
  PROVIDER_EDIT_TRANSLATIONS_TITLE: 'provider-edit-translations-title',
  PROVIDER_DETAILS_DESCRIPTION: 'provider-details-description',
  PROVIDER_DETAILS_TITLE: 'provider-details-title',
  UPDATES_ID: 'updates-id',
  UPDATES_TABLE: 'updates-table',
  UPDATES_MORE_BTN: 'updates-more-btn',
  UPDATES_MORE_CHILD_BTN: 'updates-more-child-btn',
  UPDATES_STATUS_DIALOG_OPTION: 'updates-status-dialog-option',
  UPDATES_STATUS_DIALOG: 'updates-status-dialog',
  UPDATES_DETAILS_STATUS: 'updates-details-status',
  UPDATE_DETAILS_TITLE: 'update-details-title',
  UPDATE_DETAILS_LEFT_SECTION_TEXT: 'update-details-left-section-text',
  UPDATE_DETAILS_DESCRIPTION: 'update-details-description',
  NEW_UPDATE_HEADER_TITLE: 'new-update-header-title',
  EDIT_UPDATE_HEADER_TITLE: 'edit-update-header-title',
  DUPLICATE_UPDATE_HEADER_TITLE: 'duplicate-update-header-title',
  NEW_UPDATE_REORDER_UI_BTN: 'new-update-reorder-ui-btn',
  NEW_ANNOUNCEMENT_TITLE: 'new-announcement-title',
  ANNOUNCEMENTS_TABLE: 'announcements-table',
  ANNOUNCEMENTS_ID: 'announcements-id',
  ANNOUNCEMENT_DETAILS_STEPS: 'announcement-details-steps',
  ANNOUNCEMENT_DETAILS_NAME: 'announcement-details-name',
  POINTS_DISTRIBUTION_TABLE: 'points-distribution-table',
  NEW_POINT_DISTRIBUTION_TITLE: 'new-point-distribution-title',
  NEW_POINT_DISTRIBUTION_USERS: 'new-point-distribution-users',
  NEW_POINT_DISTRIBUTION_POINTS: 'new-point-distribution-points',
  POINT_DISTRIBUTION_NAME: 'point-distribution-name',
  POINT_DISTRIBUTION_ID: 'point-distribution-id',
  POINT_DISTRIBUTION_DETAILS_POINTS: 'point-distribution-points',
  POINT_DISTRIBUTION_DETAILS_TEXT: 'point-distribution-text',
  INVOICE_ID: 'invoice-id',
  INVOICES_TABLE: 'invoices-table',
  INVOICES_TABLE_CELL: 'invoices-table-cell',
  INVOICE_DOWNLOAD_BTN: 'invoice-download-btn',
  INVOICE_TYPE: 'invoice-type',
  INVOICE_LIST_TITLE: 'invoice-list-title',
  INVOICE_REPORT_INFO: 'invoice-report-info',
  NEW_INVOICE_UPDATE_LIST_BTN: 'new-invoice-update-list-btn',
  NEW_INVOICE_CAMPAIGN_ID: 'new-invoice-campaign-id',
  NEW_INVOICE_OFFER_ID: 'new-invoice-offer-id',
  SEGMENTS_TABLE: 'segments-table',
  SEGMENTS_TABLE_ID: 'segments-table-id',
  NEW_SEGMENT_HEADER: 'new-segment-header',
  UPDATE_SEGMENT_HEADER: 'update-segment-header',
  EDIT_SEGMENT_HEADER: 'edit-segment-header',
  NEW_INVITE_SEGMENT_CODE_SECTION: 'new-invite-segment-code-section',
  CREATE_SEGMENT_HEADER: 'create-segment-title',
  CREATE_SEGMENT_BUTTON: 'create-segment-button',
  UPDATE_SEGMENT_BUTTON: 'update-segment-button',
  UPDATE_SEGMENT_MODIFICATION_TYPE: 'update-segment-modification-type',
  UPDATE_SEGMENT_DIALOG_NAME: 'update-segment-dialog-name',
  CREATE_SEGMENT_NAME: 'create-segment-name',
  CREATE_SEGMENT_CODES_COUNT: 'create-segments-codes-count',
  SEGMENTS_DETAILS_USER_COUNT: 'segments-details-user-count',
  SEGMENTS_DETAILS_CODES_COUNT: 'segments-details-codes-count',
  SEGMENTS_DETAILS_TYPE: 'segments-details-type',
  SEGMENTS_DETAILS_TITLE: 'segments-details-title',
  TARGET_GROUPS_USERS_TABLE: 'group-users-table',
  TARGET_GROUPS_USERS_TABLE_ID: 'group-users-table-id',
  CATALOG_SOCKET_LANG: 'catalog-socket-lang',
  CATALOG_SOCKET_CURRENCY: 'catalog-socket-currency',
  CATALOG_SOCKET: 'catalog-socket',
  CATALOG_SOCKETS_TITLE: 'catalog-sockets-title',
  CATALOG_SOCKET_SELECT_BTN: 'catalog-socket-select-btn',
  CATALOG_SOCKET_ID: 'catalog-socket-id',
  CATALOG_SOCKET_PRODUCTS_ID: 'catalog-socket-products-id',
  CATALOG_SOCKETS_PRODUCTS_TITLE: 'catalog-sockets-products-title',
  CATALOG_SOCKET_PRODUCTS_CARD: 'catalog-socket-products-card',
  CATALOG_PRODUCT_TITLE: 'catalog-product-title',
  CATALOG_PRODUCT_ID: 'catalog-product-id',
  ACTION_BOX_TABLE: 'action-box-table',
  ACTION_BOX_ID: 'action-box-id',
  ACTION_BOX_DETAILS_ID: 'action-box-details-id',
  ACTION_BOX_DETAILS_TITLE: 'action-box-details-title',
  ACTION_BOX_DETAILS_LAUNCH_DATE: 'action-box-details-launch-date',
  NEW_ACTION_BOX_HEADER_TITLE: 'new-action-box-header-title',
  NEW_ACTION_BOX_REORDER_UI_BTN: 'new-action-box-reorder-ui-btn',
  EDIT_ACTION_BOX_HEADER_TITLE: 'edit-action-box-header-title',
  CAMPAIGN_OPEN_NOTES_BTN: 'campaign-open-notes-btn',
  CAMPAIGN_EDIT_NOTES_BTN: 'campaign-edit-notes-btn',
  CAMPAIGN_EDIT_NOTE_INPUT: 'campaign-edit-note-input',
  CAMPAIGN_DETAILS_NOTE_INPUT: 'campaign-details-note-input',
  CONDITION_CAMPAIGN_DIALOG_TITLE: 'condition-campaign-dialog-title',
  CONDITION_CAMPAIGN_DIALOG: 'condition-campaign-dialog',
  CONDITION_CAMPAIGN_DETAILS_DIALOG: 'condition-campaign-details-dialog',
  CONDITION_CAMPAIGN_ITEM: 'condition-campaign-item',
  CONDITION_CAMPAIGN_ITEM_DESCRIPTION: 'condition-campaign-item-description',
  CONDITION_CAMPAIGN_ITEM_EDIT: 'condition-campaign-item-edit',
  CONDITION_CAMPAIGN_ITEM_DELETE: 'condition-campaign-item-delete',
  CONDITION_CAMPAIGN_ITEM_DETAILS: 'condition-campaign-item-details',
  CONDITION_CAMPAIGN_ERROR: 'condition-campaign-error',
  BUSINESS_USERS_TABLE: 'business-users-table',
  BUSINESS_USERS_ID: 'business-users-id',
  BUSINESS_USER_DETAILS_NAME: 'business-user-details-name',
  BUSINESS_USER_DETAILS_OPTIONS_BTN: 'business-user-details-option-btn',
  NEW_BUSINESS_USER_TITLE: 'new-business-user-title',
  NEW_BUSINESS_USER_NAME: 'new-business-user-name',
  NEW_PROGRAM_TITLE: 'new-program-title',
  EDIT_PROGRAM_TITLE: 'edit-program-title',
  NEW_PROGRAM_SETTINGS_ACCESS: 'new-program-settings-access',
  NEW_PROGRAM_JOIN_ERROR: 'new-program-join-error',
  NEW_PROGRAM_DISTRIBUTION_ERROR: 'new-program-distribution-error',
  NEW_PROGRAM_CODE_GENERATOR_METHOD: 'new-program-code-generator-method',
  PROGRAM_DETAILS_NAME: 'program-details-name',
  PROGRAMS_TABLE: 'programs-table',
  PROGRAM_ID_TABLE: 'program-id-table',
  EDITED_PROGRAM_NAME: 'edited-program-name',
  DUPLICATED_PROGRAM_NAME_DIALOG: 'duplicated-program-name-dialog',
  USER_ID_COPY_BUTTON: 'user-id-copy-button'
}

export const CAMPAIGNS_TABLE_COLUMNS = {
  ID: 0,
  CATEGORY: 1,
  TITLE: 2,
  FEATURED_POSITION: 3,
  INCLUDED_SEGMENTS: 4,
  TRANSLATIONS: 5,
  STATUS: 6,
  DATE: 7
}

export const CAMPAIGN_USERS_PARTICIPATING_TABLE_COLUMNS = {
  ID: 0,
  TIMES: 1,
  DATE: 2
}

export const OFFERS_TABLE_COLUMNS = {
  ID: 1,
  CATEGORY: 2,
  TITLE: 3,
  TYPE: 4,
  INCLUDED_SEGMENTS: 5,
  TRANSLATIONS: 6,
  STATUS: 7,
  AVAILABLE: 8,
  REDEEMED: 9
}

export const OFFER_COUPONS_CSV_COLUMNS = {
  TEST: 'test',
  TES: 'tes'
}

export const OFFERS_COUPONS_TABLE_COLUMNS = {
  CODE: 0,
  DATE: 1,
  STATUS: 2
}

export const OFFERS_CATEGORY_TABLE_COLUMNS = {
  ID: 0,
  ICON: 1,
  NAME: 2,
  LIVE_OFFERS: 3
}

export const USERS_TABLE_COLUMNS = {
  ID: 0,
  SIGNUP_DATE: 1,
  CONSENT_DATE: 2,
  NAME: 3,
  EMAIL: 4,
  STATUS: 5
}

export const USER_DETAILS_CAMPAIGN_TABLE_COLUMNS = {
  ID: 0,
  CATEGORY: 1,
  NAME: 2,
  TITLE: 3,
  FEATURED: 4
}

export const USERS_DETAILS_TRANSACTIONS_TABLE_COLUMNS = {
  DATE: 0,
  TRANSACTION_ID: 1,
  DESCRIPTION: 2,
  AMOUNT: 3
}

export const USERS_DETAILS_CONNECTED_APPS_TABLE_COLUMNS = {
  ID: 0,
  PROVIDER: 1,
  STATUS: 2
}

export const USERS_DETAILS_UPDATES_TABLE_COLUMNS = {
  ID: 0,
  NAME: 1,
  TITLE: 2
}

export const UPDATES_TABLE_COLUMNS = {
  ID: 0,
  TITLE: 1,
  SEGMENTS: 2,
  TRANSLATIONS: 3,
  STATUS: 4,
  DATE: 5
}

export const ANNOUNCEMENTS_TABLE_COLUMNS = {
  ID: 0,
  DATE: 1,
  NAME: 2,
  TITLE: 3
}

export const POINTS_DISTRIBUTION_TABLE_COLUMNS = {
  ID: 0,
  DATE: 1,
  NAME: 2,
  USERS: 3,
  STATUS: 4
}

export const INVOICES_TABLE_COLUMNS = {
  ID: 0,
  TYPE: 1,
  CREATED_DATE: 2,
  PERIOD_DATE: 3,
  ACTION: 4
}

export const SEGMENTS_TABLE_COLUMNS = {
  ID: 0,
  CREATED_DATE: 1,
  NAME: 2,
  TYPE: 3,
  USERS: 4
}

export const EDIT_SEGMENTS_CODE_MODIFICATION_TYPE = {
  DELETE_ALL: 0,
  REPLACE_LIST: 1,
  MODIFY_THE_NUMBER_CAN_BE_USED: 2,
  MANUALLY_ADD_MORE_CODES: 3,
  DONT_MAKE_MODIFICATIONS: 4
}

export const CATALOG_LABELS = {
  LANGUAGE: 'en',
  CURRENCY: 'USD'
}

export const ACTION_BOX_TABLE_COLUMNS = {
  ID: 0,
  CATEGORY: 1,
  TITLE: 2,
  UI_POSITION: 3,
  LAUNCH_DATE: 4
}

export const CY_OFFER_TYPES = {
  DIRECT: 'Direct',
  UNIQUE_CODE: 'Unique Code',
  DIRECT_EXPIRE: 'Direct Expire',
  DIRECT_EXPIRE_TICKET: 'Direct Expire Ticket',
  CREDIT_PASS: 'Credit Pass',
  CATALOG: 'Catalog',
  FUNDS_TO_WALLET: 'Funds'
}

export const BUSINESS_USERS_TABLE_COLUMNS = {
  ID: 0,
  DATE: 1,
  JOINED: 2,
  NAME: 3,
  EMAIL: 4,
  ACTIVE_PROGRAMS: 5,
  STATUS: 6
}

export const PROGRAMS_TABLE_COLUMNS = {
  ID: 0,
  NAME: 1,
  BUSINESS: 2,
  DATES: 3,
  REWARDS: 4,
  STATUS: 5
}
